import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "height": "calc(100vh - 60px)",
    "width": "100vw",
    "position": "relative"
  }
};
const _hoisted_2 = {
  class: "drawer-class"
};
const _hoisted_3 = {
  style: {
    "flex": "auto",
    "margin-top": "2%"
  }
};
import { ref, onMounted, onUnmounted, watch } from 'vue';
// import { DrawerProps } from 'element-plus';
// import { ElLoading } from 'element-plus';
import 'element-plus/theme-chalk/display.css';
import { OrbitControls } from 'three/addons/controls/OrbitControls';
import { camera, initScene, initEnv, renderer, onClick, drawerId, animateid, scene } from './home.js';

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  __name: 'Home',
  setup(__props) {
    const threeLoading = ref();
    let drawer1 = ref(false);
    let drawer2 = ref(false);
    let drawer3 = ref(false);
    const sceneContainer = ref(null);
    let direction = ref('rtl');
    // if(animateid !== null){
    //   cancelAnimationFrame(id);
    // }

    watch(drawerId, newVal => {
      drawer1.value = newVal == 1 ? true : false;
      drawer2.value = newVal == 2 ? true : false;
      drawer3.value = newVal == 3 ? true : false;
    }, {
      immediate: true
    });
    let resizeObserver;
    function directionChange(event) {
      if (event.matches) {
        direction.value = 'btt';
      } else {
        direction.value = 'rtl';
      }
    }
    onMounted(() => {
      if (renderer == null) {
        initEnv();
      }
      threeLoading.value = ElLoading.service({
        target: sceneContainer.value,
        body: true,
        text: '正在加载......'
      });
      if (animateid != null) {
        cancelAnimationFrame(animateid);
      }
      var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) && window.orientation == 0;
      if (flag) {
        direction.value = 'btt';
      }
      resizeObserver = new ResizeObserver(entries => {
        // 更新渲染器的尺寸
        for (let entry of entries) {
          renderer.setSize(entry.contentRect.width, entry.contentRect.height);
          camera.aspect = entry.contentRect.width / entry.contentRect.height;
          camera.updateProjectionMatrix();
        }
      });
      resizeObserver.observe(sceneContainer.value);
      let match = window.matchMedia("(orientation: portrait)");
      match.addEventListener("change", directionChange);
      renderer.setSize(sceneContainer.value.clientWidth, sceneContainer.value.clientHeight);
      initScene();
      sceneContainer.value.appendChild(renderer.domElement);
      threeLoading.value.close();
      const controls = new OrbitControls(camera, renderer.domElement);
      controls.enablePan = false;
      controls.enableZoom = false;
      window.addEventListener('click', onClick);
    });
    onUnmounted(() => {
      //  renderer.dispose();
      // resizeObserver.unobserve(sceneContainer.value);
      resizeObserver.disconnect();
      window.removeEventListener('click', onClick);
      window.removeEventListener('change', directionChange);
      cancelAnimationFrame(animateid);
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          xs: 24,
          md: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            ref_key: "sceneContainer",
            ref: sceneContainer,
            style: {
              "height": "calc(100vh - 60px)",
              "background-color": "rgb(179, 225, 157)"
            }
          }, null, 512)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_drawer, {
            modelValue: _unref(drawer1),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(drawer1) ? drawer1.value = $event : drawer1 = $event),
            title: "慧农平台",
            direction: _unref(direction),
            size: "50%",
            style: {
              "background-color": "rgb(209, 237, 196)"
            },
            resizable: ""
          }, {
            default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("span", null, "基于当代先进开放技术框架打造的全新一代中小型应用系统开发平台。", -1)), _cache[4] || (_cache[4] = _createElementVNode("span", null, "前后端分离式开发模式，小型应用前端可使用Vue,React,后端可使用Express。", -1)), _cache[5] || (_cache[5] = _createElementVNode("span", null, "中型应用前端可使用Vue,React,后端可使用SpringBoot和SpringSecurity", -1)), _createVNode(_component_el_image, {
              src: require('../assets/p002.png'),
              style: {
                "margin-top": "4%"
              }
            }, null, 8, ["src"])]),
            _: 1
          }, 8, ["modelValue", "direction"]), _createVNode(_component_el_drawer, {
            modelValue: _unref(drawer2),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(drawer2) ? drawer2.value = $event : drawer2 = $event),
            title: "态势感知",
            direction: _unref(direction),
            size: "50%",
            style: {
              "background-color": "rgb(209, 237, 196)"
            },
            resizable: ""
          }, {
            default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("span", null, "数据态势感知技术是基于VUE和SpringBoot开发的小型数据分析、展示系统。", -1)), _cache[7] || (_cache[7] = _createElementVNode("span", null, "前后端分离式开发模式，前端使用Vue,ElementPlus,后端使用SpringBoot或Express。", -1)), _createVNode(_component_el_image, {
              src: require('../assets/p004.png'),
              style: {
                "margin-top": "4%"
              }
            }, null, 8, ["src"])]),
            _: 1
          }, 8, ["modelValue", "direction"]), _createVNode(_component_el_drawer, {
            modelValue: _unref(drawer3),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(drawer3) ? drawer3.value = $event : drawer3 = $event),
            direction: _unref(direction),
            size: "50%",
            style: {
              "background-color": "rgb(209, 237, 196)"
            }
          }, {
            header: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("h4", null, "慧商平台", -1)]))]),
            default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("div", null, " 基于微服务架构的慧商平台，拟在中大型复杂应用中，充分利用分布式计算的优势，在前后端分离开发的基础上，通过集中式服务注册及配置、网关、负载均衡及服务监测、熔断等成熟技术，实现应用的快速开发、迭代和部署。 ", -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_image, {
              src: require('../assets/p200.png')
            }, null, 8, ["src"])])]),
            _: 1
          }, 8, ["modelValue", "direction"])])]),
          _: 1
        })]),
        _: 1
      }), _cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "index_text hidden-xs-only"
      }, "方实方毅  允公允能", -1)), _cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "icp-bottom"
      }, [_createElementVNode("img", {
        style: {
          "width": "25px",
          "height": "25px",
          "border-radius": "50%",
          "flex-item": "1"
        },
        src: "/icp.png"
      }), _createElementVNode("a", {
        href: "https://beian.miit.gov.cn/",
        target: "_blank",
        class: "icp"
      }, "  沪ICP备2025120713号-1")], -1))]);
    };
  }
};